import { Helmet } from "react-helmet";
import React from "react";
import "./style.scss";
import DaneProfileImage from "../../assets/images/dane.png";
import LivestreamPage from "../common/LivestreamPage";
import VerifiedIcon from "@mui/icons-material/Verified";

function MarketAnalysis() {
  // Custom body layout to match original two-column design
  const CustomBody = () => (
    <div className="market-analysis-presentor-wrapper">
      <div className="market-analysis-half-width">
        <div className="market-analysis-presentor">
          <img
            src={DaneProfileImage}
            alt="profile"
            className="market-analysis-presentor-avatar"
          />
          <div className="market-analysis-presentor-detail">
            <div className="market-analysis-presentor-name">
              Dane Glisek <VerifiedIcon />
            </div>
            <div className="market-analysis-presentor-position">
              TradeAlgo Analyst
            </div>
          </div>
        </div>

        <div className="market-analysis-event-info">
          <div className="market-analysis-event-info-section">
            <div className="market-analysis-event-title">
              Pre-market Analysis Sessions
            </div>
            <div className="market-analysis-event-description">
              <div>
                Every Monday to Friday
                <br />
                9:00AM - 9:30AM EST
              </div>
              <div>
                Dane will go over TradeAlgo to identify potential dashboard
                picks, providing levels to watch out for with day-trades and set
                ups.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="market-analysis-half-width">
        <div
          className="market-analysis-presentor"
          style={{ visibility: "hidden" }}
        >
          <img
            src={DaneProfileImage}
            alt="profile"
            className="market-analysis-presentor-avatar"
          />
          <div className="market-analysis-presentor-detail">
            <div className="market-analysis-presentor-name">
              Dane Glisek <VerifiedIcon />
            </div>
            <div className="market-analysis-presentor-position">
              TradeAlgo Analyst
            </div>
          </div>
        </div>
        <div className="market-analysis-event-info">
          <div className="market-analysis-event-info-section">
            <div className="market-analysis-event-title">
              Live Trading Sessions
            </div>
            <div className="market-analysis-event-description">
              <div>
                Every Monday to Friday
                <br />
                9:30AM - 10:30AM and 3:00PM - 4:00PM EST
              </div>
              <div>
                These group training sessions are designed to explain how to
                take full advantage of the alerts TradeAlgo has to offer.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-xl-live">
      <Helmet>
        <title>Live Trading Room | TradeAlgo</title>
      </Helmet>

      <LivestreamPage
        eventID="1439418"
        videoKey="market-analysis"
        customBodyComponent={<CustomBody />}
        showPreviousVideos={true}
        customPageSize={19}
        className="market-analysis-page"
      />
    </div>
  );
}
export default MarketAnalysis;
